const ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST = 'ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST';
const ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_SUCCESS = 'ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_SUCCESS';
const ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_FAILURE = 'ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_FAILURE';

export {
  ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST,
  ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_SUCCESS,
  ACTION_TYPE_ADD_NEW_COMPANY_USER_REQUEST_FAILURE,
};
